import { Type } from 'class-transformer';
import { serializeType } from './common';
import { EmergencyContact } from './employee';
import { User } from './user';

export class Contractor extends User {

  partnerId: number;        // vendor trading partner id
  partner;                  // vendor trading partner
  projectId: number;        // project id
  @Type(serializeType(EmergencyContact)) emergencyContacts: EmergencyContact[];
}